<template>
  <div
    :class="{ 'load load--fill': isLoading }"
    class="p-4 py-8"
  >
    <section>
      <div class="max-w-3xl">
        <div class="w-full input-group">
          <input
            v-model="search"
            type="text"
            placeholder="Search Managed Pages"
          >
        </div>
        <div
          v-if="managedPages.data.length"
          class="flex flex-wrap items-stretch"
        >
          <div
            v-for="managedPage in managedPages.data"
            :key="managedPage.uuid"
            class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card"
          >
            <ManagedPageCard
              :managed-page="managedPage"
              @openDeleteModal="openDeleteModal"
              @openDisableModal="openDisableModal"
              @openEnableModal="openEnableModal"
            />
          </div>
          <Pagination
            :pagination="managedPages.meta.pagination"
            :on-change="updatePagination"
          />
        </div>
        <div
          v-else
          class="empty"
        >
          <section>
            <h2 v-text="noneFoundText" />
            <p>
              Managed Pages are available to members within the mobile application.
              <a
                target="_blank"
                rel="noopener noreferrer"
                :href="$root.baseSupportUrl"
                v-text="'Have a question about the way they work?'"
              />
            </p>
          </section>
        </div>
      </div>
      <DeleteManagedPageModal
        :show="showDeleteModal"
        :managed-page="selectedManagedPage"
        @destroyed="loadManagedPages"
        @close="closeDeleteModal"
      />
      <DisableManagedPageModal
        :show="showDisableModal"
        :managed-page="selectedManagedPage"
        @disabled="loadManagedPages"
        @close="closeDisableModal"
      />
      <EnableManagedPageModal
        :show="showEnableModal"
        :managed-page="selectedManagedPage"
        @enabled="loadManagedPages"
        @close="closeEnableModal"
      />
    </section>
  </div>
</template>

<script type="text/babel">
import DeleteManagedPageModal from './modals/DeleteManagedPageModal'
import DisableManagedPageModal from './modals/DisableManagedPageModal'
import EnableManagedPageModal from './modals/EnableManagedPageModal'
import ManagedPageCard from './ManagedPageCard'
import Pagination from 'Base/Resources/assets/js/components/Pagination'
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'ManagedPages',
  components: {
    ManagedPageCard,
    DeleteManagedPageModal,
    DisableManagedPageModal,
    EnableManagedPageModal,
    Pagination,
  },
  props: {
    filter: {
      type: String,
      required: false,
      default: 'active',
    },
  },
  data() {
    return {
      isLoading: true,
      showDeleteModal: false,
      showDisableModal: false,
      showEnableModal: false,
      selectedManagedPage: {},
      search: '',
      page: 1,
    }
  },
  computed: {
    ...mapState({
      managedPages: state => state.managedPage.managedPages,
    }),
    noneFoundText() {
      if (this.search) {
        return `There are no ${this.filter} Managed Pages matching your search.`
      }

      return `There are no ${this.filter} Managed Pages.`
    },
  },
  watch: {
    filter() {
      this.page = 1
      this.search = ''

      this.loadManagedPages()
    },
    search: debounce(function () {
      if (this.page === 1 ) {
        this.loadManagedPages()
      } else {
        this.page = 1
      }
    }, 500),
    page() {
      this.loadManagedPages()
    },
  },
  mounted() {
    this.loadManagedPages()
  },
  methods: {
    ...mapActions({
      getManagedPages: 'managedPageGetManagedPages',
    }),
    loadManagedPages: debounce(function () {
      this.isLoading = true

      this.getManagedPages({
        filter: this.filter,
        search: this.search,
        page: this.page,
      }).then(() => {
        this.isLoading = false
      })
    }, 500),
    openDisableModal(managedPage) {
      this.selectedManagedPage = managedPage
      this.showDisableModal = true
    },
    openDeleteModal(managedPage) {
      this.selectedManagedPage = managedPage
      this.showDeleteModal = true
    },
    openEnableModal(managedPage) {
      this.selectedManagedPage = managedPage
      this.showEnableModal = true
    },
    closeDisableModal() {
      this.selectedManagedPage = {}
      this.showDisableModal = false
    },
    closeDeleteModal() {
      this.selectedManagedPage = {}
      this.showDeleteModal = false
    },
    closeEnableModal() {
      this.selectedManagedPage = {}
      this.showEnableModal = false
    },
    updatePagination(page){
      this.page = page
    },
  },
}
</script>
